import React from 'react';
import { FaUserShield, FaCashRegister, FaUserTag } from 'react-icons/fa';

const AutorityTag = ({ autority, position = 'center' }) => {
  const TagPosition = position === 'right'
    ? 'justify-end'
    : position === 'left'
      ? 'justify-start'
      : 'justify-center';

  let tagStyle = 'bg-gray-300 dark:bg-gray-600';
  let label = 'Desconocido';
  let Icon = null;

  switch (autority?.toUpperCase()) {
    case 'ADMIN':
      tagStyle = 'bg-gradient-to-r from-red-500 to-red-700 dark:from-red-400 dark:to-red-600';
      label = 'Administrador';
      Icon = FaUserShield;
      break;
    case 'CAJERO':
      tagStyle = 'bg-gradient-to-r from-green-400 to-green-600 dark:from-green-500 dark:to-green-700';
      label = 'Cajero';
      Icon = FaCashRegister;
      break;
    case 'VENDEDOR':
      tagStyle = 'bg-gradient-to-r from-amber-400 to-amber-500 dark:from-amber-500 dark:to-amber-600';
      label = 'Vendedor';
      Icon = FaUserTag;
      break;
  }

  return (
    <div className={`flex ${TagPosition} items-center`}>
      <span className={`text-sm font-bold ${tagStyle} text-white py-1 px-3 rounded-xl flex items-center gap-2 shadow-md`}>
        {Icon && <Icon size={18} />}
        {label}
      </span>
    </div>
  );
};

export default AutorityTag;


